import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  Image,
  ScrollView,
  ActivityIndicator,
} from "react-native";

import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import ProgessIndicator from "@components/ProgessIndicator";
import CustomText from "@components/CustomText";
import color from "@constants/color";
import { fetchPerformanceMetricsData } from "@services/api";
import VideoInfoModal from "./VideoInfoModal";
import analytics from "@services/analytics";
import { PERFORMANCE_MATRICES } from "@constants/analyticsEventsCT";

const PerformanceMetrics = ({ route }) => {
  const navigation = useNavigation();

  const [currentPM, setCurrentPM] = useState([]);
  const [previousPM, setPreviousPM] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    analytics.trackEvent(PERFORMANCE_MATRICES.REPORT_LANDED);
    const getPMDetails = async (setData, type) => {
      try {
        const { data } = await fetchPerformanceMetricsData(type);
        setData(data?.data);
        if (type === "CURRENT") setIsLoading(false);
      } catch (error) {
        console.log("error : ", error);
      }
    };
    getPMDetails(setCurrentPM, "CURRENT");
    getPMDetails(setPreviousPM, "PREVIOUS");
  }, []);

  const WeeklyCard = ({
    info,
    backgroundColor,
    headerStyle = {},
    headerContainer = {},
    titleStyle = {},
    titleContainer = {},
  }) => (
    <>
      {info && (
        <View style={[styles.WeeklyCard, { backgroundColor }]}>
          <View style={headerContainer}>
            <CustomText
              variant="body_text_2"
              style={[headerStyle, { color: color.mediumBlack }]}
            >
              {info?.header}
            </CustomText>
          </View>
          <View style={titleContainer}>
            <View>
              <CustomText
                variant="title_20"
                style={[titleStyle, styles.wcTitle]}
              >
                {info?.title}
              </CustomText>
              {info?.subtitle && (
                <CustomText variant="body_text_3" style={styles.wcSubTitle}>
                  {info?.subtitle}
                </CustomText>
              )}
            </View>
            {info?.video_info && (
              <View style={styles.videoContainer}>
                <VideoInfoModal videoInfo={info?.video_info} />
              </View>
            )}
          </View>
          {info?.list && Array.isArray(info.list)
            ? info.list.map((val) => (
                <View style={styles.cardContainer}>
                  <View style={{ flexDirection: "row", flex: 5 }}>
                    <Image
                      source={{
                        uri: val?.icon,
                      }}
                      style={styles.cardIcon}
                    />
                    <View>
                      <CustomText
                        variant="body_text_3"
                        style={styles.cardTitle}
                      >
                        {val?.title}
                      </CustomText>
                      <CustomText
                        variant="body_text_2"
                        style={styles.cardValue}
                      >
                        {val?.value}
                      </CustomText>
                    </View>
                  </View>
                  <View style={{ flex: 8 }}>
                    <ProgessIndicator
                      current={val?.percentage}
                      expectation={val.expectation}
                      title={val?.title}
                      screen={"report page"}
                    />
                  </View>
                </View>
              ))
            : null}
        </View>
      )}
    </>
  );

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />
      <ScrollView>
        {isLoading && (
          <View style={styles.loaderContainer}>
            <ActivityIndicator color={color.primary} size="large" />
          </View>
        )}
        <WeeklyCard
          key={currentPM[0]?.header}
          info={currentPM[0]}
          backgroundColor={color.white}
          headerContainer={styles.wcHeader}
          titleStyle={{ lineHeight: 28 }}
          titleContainer={styles.wcTitleContainer}
        />
        {previousPM && Array.isArray(previousPM) ? (
          <>
            {previousPM.map((info) => (
              <WeeklyCard
                key={`${info?.header}-${info?.list}`}
                info={info}
                backgroundColor="rgba(0, 0, 0, 0.04)"
                headerStyle={{ fontSize: 12 }}
                titleStyle={{ fontSize: 16, lineHeight: 24 }}
                titleContainer={[styles.wcTitleContainer, { marginTop: 2 }]}
              />
            ))}
            <View
              style={{ backgroundColor: "rgba(0, 0, 0, 0.04)", height: 16 }}
            />
          </>
        ) : null}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  WeeklyCard: { paddingHorizontal: 16, paddingTop: 20, paddingBottom: 4 },
  wcHeader: {
    alignSelf: "flex-start",
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
  wcTitleContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
    marginBottom: 16,
  },
  wcTitle: { color: color.mediumBlack },
  wcSubTitle: { color: color.lightBlack },
  videoContainer: { marginTop: -20 },
  cardContainer: {
    backgroundColor: color.white,
    padding: 12,
    marginBottom: 12,
    borderRadius: 8,
    borderColor: color.blank_grey,
    borderWidth: 1,
    elevation: 8,
    flexDirection: "row",
  },
  cardIcon: { height: 24, width: 24, marginRight: 8, marginTop: 2 },
  cardTitle: { color: color.lightBlack },
  cardValue: { color: color.mediumBlack },
  loaderContainer: {
    height: 364,
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default PerformanceMetrics;
